/**
 * @generated SignedSource<<aa99a0a23f9cb63008ff0b0e0ebe2f4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamRefetchQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  id: string;
  loginOverriden?: boolean | null;
  loginTypes?: ReadonlyArray<string | null> | null;
  resourceGroupIds?: ReadonlyArray<string | null> | null;
  resourceGroupPermissions?: ReadonlyArray<string | null> | null;
  role?: string | null;
  uuid?: any | null;
};
export type TeamRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamView_organization">;
  } | null;
};
export type TeamRefetchQuery = {
  response: TeamRefetchQuery$data;
  variables: TeamRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loginOverriden"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loginTypes"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceGroupIds"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceGroupPermissions"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "role"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v10 = {
  "kind": "Variable",
  "name": "loginOverriden",
  "variableName": "loginOverriden"
},
v11 = {
  "kind": "Variable",
  "name": "loginTypes",
  "variableName": "loginTypes"
},
v12 = {
  "kind": "Variable",
  "name": "resourceGroupIds",
  "variableName": "resourceGroupIds"
},
v13 = {
  "kind": "Variable",
  "name": "resourceGroupPermissions",
  "variableName": "resourceGroupPermissions"
},
v14 = {
  "kind": "Variable",
  "name": "role",
  "variableName": "role"
},
v15 = {
  "kind": "Variable",
  "name": "uuid",
  "variableName": "uuid"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loginType",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "providerType",
  "storageKey": null
},
v23 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "TeamView_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v18/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email",
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expiry",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "organizationPermission",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LoginTypes",
                            "kind": "LinkedField",
                            "name": "supportedLoginOptions",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IdentityProviderConfiguration",
                                "kind": "LinkedField",
                                "name": "identityProviderConfiguration",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LoginTypesConnection",
                            "kind": "LinkedField",
                            "name": "loginTypes",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LoginTypesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LoginTypes",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "authEnabled",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "IdentityProviderConfiguration",
                                        "kind": "LinkedField",
                                        "name": "identityProviderConfiguration",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v21/*: any*/),
                                          (v22/*: any*/),
                                          (v19/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v23/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "loginTypesOverriden",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "organizationNotes",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserResourceGroupLinkConnection",
                            "kind": "LinkedField",
                            "name": "resourceGroupLinks",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserResourceGroupLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserResourceGroupLink",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "resourceGroupId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "resourceGroupName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "resourceGroupPermission",
                                        "storageKey": null
                                      },
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "filters": [
                  "uuid",
                  "role",
                  "resourceGroupIds",
                  "resourceGroupPermissions",
                  "loginTypes",
                  "loginOverriden"
                ],
                "handle": "connection",
                "key": "TeamView_users",
                "kind": "LinkedHandle",
                "name": "users"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9de6cf78a906a32bce86b0adb2f2f483",
    "id": null,
    "metadata": {},
    "name": "TeamRefetchQuery",
    "operationKind": "query",
    "text": "query TeamRefetchQuery(\n  $count: Int = 10\n  $cursor: String\n  $loginOverriden: Boolean\n  $loginTypes: [String]\n  $resourceGroupIds: [String]\n  $resourceGroupPermissions: [String]\n  $role: String\n  $uuid: UUID\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...TeamView_organization_8Azgg\n    id\n  }\n}\n\nfragment TeamView_organization_8Azgg on Organization {\n  id\n  users(uuid: $uuid, role: $role, resourceGroupIds: $resourceGroupIds, resourceGroupPermissions: $resourceGroupPermissions, loginTypes: $loginTypes, loginOverriden: $loginOverriden, first: $count, after: $cursor) {\n    totalCount\n    edges {\n      node {\n        id\n        email\n        uuid\n        displayName\n        firstName\n        lastName\n        expiry\n        organizationPermission\n        supportedLoginOptions {\n          loginType\n          identityProviderConfiguration {\n            name\n            providerType\n            id\n          }\n          id\n        }\n        loginTypes {\n          edges {\n            node {\n              loginType\n              authEnabled\n              identityProviderConfiguration {\n                id\n                name\n                providerType\n                uuid\n              }\n              id\n            }\n          }\n        }\n        ...UserProfile_loginTypes\n        loginTypesOverriden\n        resourceGroupLinks {\n          edges {\n            node {\n              id\n              resourceGroupId\n              resourceGroupName\n              resourceGroupPermission\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment UserProfile_loginTypes on User {\n  id\n  uuid\n  email\n  firstName\n  lastName\n  organizationPermission\n  loginTypesOverriden\n  expiry\n  organizationNotes\n  resourceGroupLinks {\n    edges {\n      node {\n        resourceGroupId\n        resourceGroupName\n        resourceGroupPermission\n        id\n      }\n    }\n  }\n  loginTypes {\n    edges {\n      node {\n        loginType\n        authEnabled\n        identityProviderConfiguration {\n          id\n          name\n          providerType\n          uuid\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "60aff5f0ec2070943783fd319cf042d1";

export default node;
